import type { Node, NodeProps } from '@xyflow/react';
import type { ProjectGraphNode } from '@avisoma/shared';
import { chevronProps, type FlowNodeData } from '../useGraphLayout';
import { kindColours } from '../kindPalette';
import { ipcAncestorLines } from '../ipcAncestors';
import { kindIcon } from '../kindIcon';
import { nodeLabel } from '../nodeLabel';
import { NodeShell } from './NodeShell';

/**
 * The card of an IPC position, and the fallback for node kinds added after this release (their icon, colour and label
 * fall back to a question mark, grey and the id); `w-40` matches their `NODE_SIZE` / `FALLBACK_SIZE`.
 */
export function GenericNode({ data }: NodeProps<Node<FlowNodeData>>) {
  const node = data.node as ProjectGraphNode;
  const label = nodeLabel(node);
  const { icon, className } = kindIcon(node.kind);
  // DR-5084: an IPC position's assemblies, one tooltip line each, top of the figure first.
  const ancestry = node.kind === 'ipc' ? ipcAncestorLines(node).map((line) => `\nin: ${line}`) : [];
  return (
    <NodeShell
      icon={icon}
      iconClassName={className}
      compactClassName={kindColours(node.kind).compact}
      label={label}
      selected={data.selected}
      focused={data.focused}
      {...chevronProps(data)}
      className="w-40"
    >
      <span
        className="block truncate text-sm text-gray-600 dark:text-zinc-300"
        title={`${node.kind}: ${label}${ancestry.join('')}`}
      >
        {label}
      </span>
    </NodeShell>
  );
}
